import Vue from 'vue'
import Vuex from 'vuex'
import common from './common'
Vue.use(Vuex)
    // 获取本地储存
let usermsg = sessionStorage.getItem('usermsg', );

let list = {
    "username": "",
    "sid": "",
    'password': '',
    'lang': ''
};
// 如果有值 
if (usermsg) {
    // 转json 对象
    list = JSON.parse(usermsg)
}
// 左侧菜单栏的index 
let leftMenu = sessionStorage.getItem('leftMenu', );
let leftMenu1 = {
    'leftMenu': ''
}
if (leftMenu) {
    // 转json 对象
    leftMenu1 = JSON.parse(leftMenu)
}
export default new Vuex.Store({
    state: {

        username: list.username,
        sid: list.sid,
        password: list.password,
        lang: list.lang,
        leftMenu: leftMenu1.leftMenu

    },

    mutations: {


        setUserMsg(state, res) {
            let {
                username,
                sid,
                password,
                lang
            } = res
            // console.log(res)
            // console.log(JSON.stringify(res))

            state.sid = sid;
            state.username = username;
            state.lang = lang;
            state.password = password
                // 本地储存
            sessionStorage.setItem("usermsg", JSON.stringify(res))
        },
        leftMenu(state, res) {
            let { leftMenu } = res
            state.leftMenu = leftMenu
            sessionStorage.setItem("leftMenu", JSON.stringify(res))

        }

    },
    actions: {

        checkUser({
            commit
        }, res) {

            commit('setUserMsg', res)
        },
        // 左侧
        checkLeftMenu({
            commit
        }, res) {

            commit('leftMenu', res)
        },

    },
    modules: {
        common
    }
})